import { createFeatureSelector, createSelector } from '@ngrx/store';
import { WorkflowsState } from './workflows.reducers';

export const selectWorkflowsState = createFeatureSelector<WorkflowsState>('workflows');

export const selectWorkflowRules = createSelector(selectWorkflowsState, (s) => s.rules);

export const selectWorkflowsLoading = createSelector(selectWorkflowsState, (s) => s.loading);

export const selectWorkflowsLoadError = createSelector(selectWorkflowsState, (s) => s.loadError);

export const selectWorkflowSchema = createSelector(selectWorkflowsState, (s) => s.schema);

export const selectWorkflowTemplates = createSelector(selectWorkflowsState, (s) => s.templates);

export const selectWorkflowSaveLoading = createSelector(
  selectWorkflowsState,
  (s) => s.saveLoading
);

export const selectWorkflowSaveCompletedAt = createSelector(
  selectWorkflowsState,
  (s) => s.saveCompletedAt
);
